/**
 * Accounts numbered by their tax-return code (a business that chose "use GIFI codes as
 * account numbers", user_businesses.coa_numbering = 'tax_code', migration 146).
 * ---------------------------------------------------------------------------------
 * The account's number is its code; when several accounts share one code the next
 * ones get -1, -2 … (two bank accounts: 1002 and 1002-1). Numbers already used in the
 * books are skipped. Mirrors nextCodeNumber() in server/routes/bookkeeping.js, which
 * decides the real numbers on Create — this is what the screens show beforehand.
 *
 * Pure + unit-tested (codeNumbering.test.ts).
 */

/** The code itself, else code-1, code-2 … — the first one not in `used` (which it joins). */
export function nextCodeNumber(used: Set<string>, code: string): string {
  let n = String(code);
  for (let i = 1; used.has(n); i++) n = `${code}-${i}`;
  used.add(n);
  return n;
}

/** Numbers for accounts in list order: key -> number ('' = the account has no code). */
export function assignCodeNumbers(rows: { key: string; code: string }[], taken: Iterable<string> = []): Map<string, string> {
  const used = new Set<string>(Array.from(taken, String));
  const out = new Map<string, string>();
  rows.forEach(r => out.set(r.key, r.code ? nextCodeNumber(used, r.code) : ''));
  return out;
}
